export const isExternalLink = (url) => {
  const tmp = document.createElement('a');
  tmp.href = url;
  return tmp.host !== window.location.host;
};

export const openExternalLink = (url) => {
  window.open(url, '_blank');
};
